__turbopack_context__.v({
  "className": "_3A-2oG_className",
  "variable": "_3A-2oG_variable",
});
